// extracted by mini-css-extract-plugin
export default {"Reviews":"Reviews_Reviews__62upf","Reviews__new":"Reviews_Reviews__new__zzCUd","Reviews__table":"Reviews_Reviews__table__-awm9"};